import { useDispatch, useMachineState } from '../app/context';
import { Button } from '../components/Button';
import { cx } from '../components/cx';
import { ABORT_REASON_LABEL, ABORT_REASON_TITLE } from '../domain/catalog';
import { targetLabel } from '../domain/format';
import styles from './AbortedScreen.module.css';
import common from './common.module.css';

export function AbortedScreen() {
  const { abortReason, ward, bed, stopUnconfirmed } = useMachineState();
  const dispatch = useDispatch();
  const title = abortReason ? ABORT_REASON_TITLE[abortReason] : 'Cycle Stopped';

  return (
    <section className={cx(common.screen, styles.screen)} aria-label="Cycle aborted">
      <div className={styles.card} role="alert">
        <div className={styles.status}>CYCLE ABORTED</div>
        <h1 className={styles.title}>{title}</h1>
        {abortReason && <div className={styles.reason}>{ABORT_REASON_LABEL[abortReason]}</div>}
        {stopUnconfirmed && (
          <div className={styles.unconfirmed}>
            THE LAMP DID NOT CONFIRM IT SWITCHED OFF.
            <br />
            ISOLATE THE LAMP POWER BEFORE ANYONE ENTERS THE ROOM.
          </div>
        )}
        <div className={styles.note}>
          Room {ward && bed ? targetLabel(ward.code, bed) : ''} is not sanitised. Per protocol the
          full cycle must restart from the beginning.
        </div>
        <div className={styles.actions}>
          <Button variant="primary" size="lg" onClick={() => dispatch({ type: 'RESTART_CYCLE' })}>
            RESTART FULL CYCLE
          </Button>
          <Button variant="secondary" size="lg" onClick={() => dispatch({ type: 'BACK_TO_WARDS' })}>
            RETURN TO ZONE SELECT
          </Button>
        </div>
      </div>
    </section>
  );
}
